import React from 'react';
import {Link} from 'react-router-dom';
import {Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink} from 'reactstrap';
import ConnectionStatus from '../ConnectionStatus';
import {WebSocketStatus} from '../../types';

type Props = {
    onLogout: () => void;
    wsStatus: WebSocketStatus;
};

const Header: React.FC<Props> = ({onLogout, wsStatus}) => {
    const [isOpen, setOpen] = React.useState(false);
    const handleLogout = React.useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        onLogout();
    }, [onLogout]);
    const handleToggle = React.useCallback(() => {
        setOpen(!isOpen);
    }, [isOpen]);
    return (
        <Navbar color="light" light expand="md">
            <NavbarBrand to="/" tag={Link}>
                Swarm
                <ConnectionStatus status={wsStatus} />
            </NavbarBrand>
            <NavbarToggler onClick={handleToggle} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className="ms-auto" navbar>
                    <NavItem>
                        <NavLink to="/browse" tag={Link}>Browse</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/history" tag={Link}>History</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink onClick={handleLogout} href="#">Logout</NavLink>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
    );
};

export default Header;
